export default "__VITE_ASSET__gX6yylHa__"